import { Job, WorkOrder, SystemWorkOrderStatus, WorkOrderStatus, WorkOrderStatusSystemName, GeneralSetting } from '@jms/model';
import { JobRight } from '@workbuddy/ui/modules/manage.job.shared/model';
import { JobEditorHost } from './enums';
import * as Enumerable from 'linq';

export class UpdateStatusUtility {

    public static enableUpdateStatusButton(job: Job | WorkOrder, isWorkOrder: boolean, jobRight: JobRight, host: JobEditorHost): boolean {

        if (!job)
            return false;

        if (host === JobEditorHost.Finance)
            return false;

        if (!isWorkOrder) {

            const jobStatus = job?.status as SystemWorkOrderStatus;

            if (UpdateStatusUtility.isClosedJob(jobStatus))
                return false;


            if (this.isBeforeFinalize(job?.status as SystemWorkOrderStatus))
                return jobRight?.processJob;

            return jobRight?.finaliseJob;

        } else {


            const woStatus = job?.status as WorkOrderStatus;

            if (UpdateStatusUtility.isClosedWorkOrder(woStatus))
                return false;

            if (this.isBeforeFinalize((job as WorkOrder)?.status?.systemStatus))
                return jobRight?.processWorkOrder;

            return jobRight?.finalliseWorkOrder;
        }

    }

    public static enableDispatchJobButton(job: Job, isWorkOrder: boolean, settings: GeneralSetting, host: JobEditorHost): boolean {

        if (!settings?.operations?.allowBulkDispatch)
            return false;

        if (isWorkOrder)
            return false;

        if (host === JobEditorHost.Finance)
            return false;

        const newWos = Enumerable.from(job?.workOrders)
            .where(wo => {

                if (wo?.status?.systemName === WorkOrderStatusSystemName.New)
                    return true;

                return false;
            })
            .toArray();

        return !!newWos?.length;
    }

    public static enableRevertStatusButton(workOrder: WorkOrder, isWorkOrder: boolean, jobRight: JobRight, host: JobEditorHost): boolean {

        if (!workOrder || !isWorkOrder || host === JobEditorHost.Finance)
            return false;

        const allowStatus = [
            SystemWorkOrderStatus.Closed,
            SystemWorkOrderStatus.Finalised,
            SystemWorkOrderStatus.Completed
        ]


        if (!allowStatus.includes(workOrder?.status?.systemStatus))
            return false;

        return jobRight?.reverseWorkOrderStatus;
    }

    private static isBeforeFinalize(status: SystemWorkOrderStatus) {

        const notCompleteStatus = [
            SystemWorkOrderStatus.Open,
            SystemWorkOrderStatus.InProgress,
            SystemWorkOrderStatus.OnHold,
            SystemWorkOrderStatus.Completed
        ];

        return notCompleteStatus.includes(status);
    }


    private static isClosedJob(status: SystemWorkOrderStatus) {
        return !status || status === SystemWorkOrderStatus.Closed || status === SystemWorkOrderStatus.Canceled;
    }

    private static isClosedWorkOrder(status: WorkOrderStatus) {
        return !status || status?.systemStatus === SystemWorkOrderStatus.Closed;
    }
}
